import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { EnvironmentInjector, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_ENVIRONMENT } from '../utils/environment.token';

const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//i.test(url);

export const apiUrlInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const environmentInjector = inject(EnvironmentInjector);
  const environment = environmentInjector.get(APP_ENVIRONMENT);

  if (isAbsoluteUrl(req.url)) {
    return next(req);
  }

  const baseUrl = environment.apiUrl.replace(/\/$/, '');
  const normalizedUrl = `${baseUrl}/${req.url.replace(/^\//, '')}`;

  return next(req.clone({ url: normalizedUrl }));
};
